import React from 'react';
import _get from 'lodash/get';

import { Config } from 'components';
import { useRecommendationConfig } from '../hooks';

export default function RecommendationActivationToggle() {
  const { data, isProcessing, updateData } = useRecommendationConfig();

  const isEnabled = _get(data, 'isEnabled', false);

  return (
    <Config.Section>
      <Config.Activator
        isActive={isEnabled}
        onChange={value => updateData({ isEnabled: value })}
        disabled={isProcessing}
      />
    </Config.Section>
  );
}
